import i18n from '@api/i18n';
export enum DateDropdownOptions {
    All = 'all',
    Calendar = 'calendar',
    Last7days = 'last7days',
    Last14days = 'last14days',
    Last30days = 'last30days',
    Last3months = 'last3months',
    Last6months = 'last6months',
    Last12months = 'last12months',
}

export const defaultDateDropdownOption = DateDropdownOptions.Last7days;

type DateDropdownOptionItem = {
    value: DateDropdownOptions;
    valueInUnit: number;
    unit: string;
    label: string;
};

export type DateDropdownOptionConfig = Record<DateDropdownOptions, DateDropdownOptionItem>;

export const getDateDropdownOptionsConfig = (): DateDropdownOptionConfig => {
    return {
        [DateDropdownOptions.All]: {
            label: i18n.t('all'),
            value: DateDropdownOptions.All,
            valueInUnit: 0,
            unit: '',
        },
        [DateDropdownOptions.Calendar]: {
            label: i18n.t('specificdaterange'),
            value: DateDropdownOptions.Calendar,
            valueInUnit: 0,
            unit: '',
        },
        [DateDropdownOptions.Last7days]: {
            label: i18n.t('last7days'),
            value: DateDropdownOptions.Last7days,
            valueInUnit: 7,
            unit: 'days',
        },
        [DateDropdownOptions.Last14days]: {
            label: i18n.t('last14days'),
            value: DateDropdownOptions.Last14days,
            valueInUnit: 14,
            unit: 'days',
        },
        [DateDropdownOptions.Last30days]: {
            label: i18n.t('last30days'),
            value: DateDropdownOptions.Last30days,
            valueInUnit: 30,
            unit: 'days',
        },
        [DateDropdownOptions.Last3months]: {
            label: i18n.t('last3months'),
            value: DateDropdownOptions.Last3months,
            valueInUnit: 3,
            unit: 'months',
        },
        [DateDropdownOptions.Last6months]: {
            label: i18n.t('last6months'),
            value: DateDropdownOptions.Last6months,
            valueInUnit: 6,
            unit: 'months',
        },
        [DateDropdownOptions.Last12months]: {
            label: i18n.t('lastyear'),
            value: DateDropdownOptions.Last12months,
            valueInUnit: 12,
            unit: 'months',
        },
    };
};

export const getDateRangeData = (isMobile: boolean): any[] => {
    const options = getDateDropdownOptionsConfig();
    const calendarOption = {
        label: options.calendar.label,
        value: options.calendar.value,
        borderBottom: true,
    };
    const dateRangesOptions = [
        {
            label: options.last7days.label,
            value: options.last7days.value,
        },
        {
            label: options.last14days.label,
            value: options.last14days.value,
        },
        {
            label: options.last30days.label,
            value: options.last30days.value,
        },
        {
            label: options.last3months.label,
            value: options.last3months.value,
        },
        {
            label: options.last6months.label,
            value: options.last6months.value,
        },
        {
            label: options.last12months.label,
            value: options.last12months.value,
        },
    ];
    if (isMobile) {
        return [...dateRangesOptions, calendarOption];
    }
    return [calendarOption, ...dateRangesOptions];
};
